var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('top-header',{attrs:{"title":_vm.$t('values')}}),_c('v-container',[_c('v-row',[_c('v-col',[_c('meter-values-table-card',{attrs:{"site-meter-values":_vm.values,"loading":_vm.loading}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }